export function lazyRetry(importFn) {
  return importFn().catch((error) => {
    const refreshed = sessionStorage.getItem("chunk-retry");
 
    if (!refreshed) {
      sessionStorage.setItem("chunk-retry", "true");
      window.location.reload();
    }
 
    throw error;
  });
}